window.selectbox_background_color_change_operation = function(selectbox_element) {
	if(selectbox_element.val() == "") return selectbox_background_color_reset_operation(selectbox_element);
	selectbox_element.removeClass(UNSELECTED_OPTION_BACKGROUND_COLOR_CLASS_NAME)
		.addClass(SELECTED_OPTION_BACKGROUND_COLOR_CLASS_NAME);
}

window.selectbox_background_color_reset_operation = function(selectbox_element) {
	selectbox_element.removeClass(SELECTED_OPTION_BACKGROUND_COLOR_CLASS_NAME)
		.addClass(UNSELECTED_OPTION_BACKGROUND_COLOR_CLASS_NAME);
}

window.initial_selectbox_background_color_set_operation = function() {
	$('select').each(function() {
		selectbox_background_color_change_operation($(this));
	});
}